export default __webpack_public_path__ + "static/media/matt-smith_0.eb390b6f.jpg";